export default __webpack_public_path__ + "static/media/blueSkyThree.90833555.jpg";